function fSelect() {
    function removeActiveState() {
        let select = document.querySelector(".js-select.is-active");

        if(select != null){
            select.classList.remove("is-active");
        }
    }

    document.addEventListener('click', function(event) {
        let select;

        if(event.target.matches('.js-select') || event.target.closest('.js-select')) {
            select = event.target.matches('.js-select') || event.target.closest('.js-select');

            if(select.matches('.is-active')) {
                removeActiveState();
            } else {
                removeActiveState();

                select.classList.add("is-active");
            }
        } else {
            if(!event.target.matches('.js-select.is-active') || event.target.closest('.js-select.is-active')) {
                removeActiveState();
            }
        }

        if(event.target.matches('.js-select-option')) {
            let parent = event.target.closest('.js-select');
            let oSelectedValue = parent.querySelector('.js-select-value');
            let oHiddenInput = parent.querySelector('input[type="hidden"]');

            if (oSelectedValue) oSelectedValue.innerHTML = event.target.innerHTML;
            if (oHiddenInput) {
                oHiddenInput.value = event.target.innerHTML;

                // Validate the field
                let error = validate.hasError(oHiddenInput);

                // If there's an error, show it
                if (error) {
                    validate.showError(oHiddenInput, error);
                    return;
                }

                // Otherwise, remove any errors that exist
                validate.removeError(oHiddenInput);

                // And add success class to field
                oHiddenInput.classList.add('is-successful');
            }
        }
    });
}
